export default __webpack_public_path__ + "images/swap_74345d.svg";